export const toKey = (key: string) =>
  decodeURIComponent(
    encodeURI(
      window.atob(key.split('').reverse().join('')).split('?').filter(Boolean).join('-'),
    ),
  );
